import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getProjectRhcertCase } from "../api/hydra";
import { IAPIError } from "../interfaces/common";
import { IProjectRhcertStatusObj } from "../interfaces/projectRhcert";

export const projectRHCertStatusQueryKey = ['projectRHCertStatus'] as const;

export const useProjectRHCertStatus = (
  projectId: string,
  enabled?: boolean
): UseQueryResult<IProjectRhcertStatusObj, IAPIError> => {
  return useQuery<IProjectRhcertStatusObj, IAPIError>({
    queryKey: [...projectRHCertStatusQueryKey, projectId],
    queryFn: async ({ signal }) => {
      try {
        const response = await getProjectRhcertCase(projectId, signal);
        return {
          responseStatus: 200,
          response
        };
      } catch (e: any) {
        return {
          responseStatus: e?.status,
          response: e
        };
      }
    },
    enabled
  });
};
